import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InvalidFieldComponent, InvalidFormComponent } from 'src/app/shared/components';
import { BackButtonComponent } from 'src/app/shared/components/back-button/back-button.component';
import { LogoFacilityComponent } from 'src/app/shared/components/logo-facility/logo.component';
import { MatStrokedButtonBorderDirective } from 'src/app/shared/directives';
import { ResetPasswordMaterialModule } from './reset-password-material-modules.module';
import { ResetPasswdComponent } from './reset-password.component';

@NgModule({
    imports: [
        CommonModule,
        ResetPasswordMaterialModule,
        LogoFacilityComponent,
        FormsModule,
        ReactiveFormsModule,
        BackButtonComponent,
        MatStrokedButtonBorderDirective,
        InvalidFormComponent,
        InvalidFieldComponent,
    ],
    declarations: [ResetPasswdComponent],
    exports: [ResetPasswdComponent],
})
export class ResetPasswordModule {}
